var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Searchkit from "@searchkit/sdk";
import buildConfiguration, { buildBaseFilters } from "./Configuration";
import buildRequest from "./Request";
import buildResponse from "./Response";
export default function handleRequest(configuration) {
    return __awaiter(this, void 0, void 0, function* () {
        const { state, queryConfig, host, cloud, index, connectionOptions, postProcessRequestBodyFn } = configuration;
        const { apiKey, headers } = connectionOptions || {};
        const searchkitConfig = buildConfiguration({
            state,
            queryConfig,
            cloud,
            host,
            index,
            apiKey,
            headers,
            postProcessRequestBodyFn
        });
        const request = Searchkit(searchkitConfig);
        const searchkitVariables = buildRequest(state, queryConfig);
        const baseFilters = buildBaseFilters(queryConfig.filters);
        const results = yield request
            .query(searchkitVariables.query)
            .setFilters(searchkitVariables.filters)
            .setSortBy(searchkitVariables.sort)
            .execute({
            facets: queryConfig.facets && Object.keys(queryConfig.facets).length > 0,
            hits: {
                from: searchkitVariables.from,
                size: searchkitVariables.size,
                includeRawHit: true
            }
        }, baseFilters);
        return buildResponse(results);
    });
}
